import { render } from "./DonorReactionsReportsTab.vue?vue&type=template&id=fddbc96e"
import script from "./DonorReactionsReportsTab.vue?vue&type=script&lang=js"
export * from "./DonorReactionsReportsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__